import {
  AxiosError,
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
} from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ValidateError, ValidateSuccess } from "./interceptor_error_message";

const onRequest = (config) => {
  return config;
};

const onRequestError = (error) => {
  console.log(`[request error] [${JSON.stringify(error)}]`);
  return Promise.reject(error);
};

const onResponse = async (response) => {
  let message = "";
  if (response && response.data) {
    const data = response.data;
    message = await ValidateSuccess(data);
    if (
      response.config.url?.includes("authentication/admin/login") ||
      response.config.url?.includes("authentication/private/admin/token")
    ) {
    } else {
      toast.success(message);
    }
  }
  return response;
};

const onResponseError = async (error) => {
  let message = "";
  if (error.response?.status === 401) {
    message = `Username dan / password salah`;
    toast.error(message);
  }
  if (error.response && error.response.data) {
    const data = error.response?.data;
    message = ValidateError(data, error.config);
    if (error.response?.status === 401) {
      message = `${message}. Please Login First!`;
      window.location.replace("/");
    }
    if (!message?.includes("Institusi tidak aktif")) toast.error(message);
  }

  return Promise.reject(error);
};

export function setupInterceptorsTo(axiosInstance) {
  axiosInstance.interceptors.request.use(onRequest, onRequestError);
  axiosInstance.interceptors.response.use(onResponse, onResponseError);
  return axiosInstance;
}
